import React from 'react';
import './CustomerCollection.css';
import SignaturePad from '../SignaturePad';
import uisFetch from '../../utils/uisFetch';
import { fetchAndConvertToBase64 } from '../../utils/FileUtils'; // newly added import

class CustomerCollection extends React.Component {
  constructor(props) {
    super(props);
    this.signaturePadRef = React.createRef();
    this.state = {
      OTP: "",
      OTPInputAlert: "",
      detail: {
        Id: 0,
        StaffERN: "",
        LastName: "",
        FirstName: "",
        PreferredName: "",
        Position: "",
        DetailList: [],
        CollectionItems: [] // ensure this field exists
      },
      SubmitAlert: "",
      CanvasUpdated: false,
      IsMobileView: false,
      IsTabletView: false,
      IsSmMobileView: false,
      modelTitle: '',
      modelImgIds: {},
      modelUniformID: '',
      collectionImages: {}, // newly added: stores Base64 images
      loadingImages: {},
      imageLoadTimestamps: {}
    };
  }

  componentWillUnmount() {
    // clear image cache (optional)
    this.setState({ collectionImages: {} });
  }

  componentDidMount() {
    // Check permission first
    if (this.props.hasPermission === false) {
      // No permission, redirect to home page
      window.location.href = process.env.PUBLIC_URL || "/";
      return;
    }

    this.setState({ OTP: "" });
    if (window.$) $('#inpOTP').focus();

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let defaultOTP = params.get('OTP');
    if (defaultOTP != null) {
      this.setState({ OTP: defaultOTP }, () => {
        this.forceUpdate();
        this.Proceed();
      });
    }

    this.updateViewType();
    window.addEventListener('resize', this.updateViewType, false);
  }

  updateViewType = () => {
    this.setState({
      IsMobileView: window.innerWidth <= 1024,
      IsTabletView: window.innerWidth >= 768,
      IsSmMobileView: window.innerWidth <= 320
    });
  };

  UpdateOTP(e) {
    this.setState({ OTP: e.target.value });
  }

  Go(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.Proceed();
    }
  }

  Proceed = () => {
    this.setState({ OTPInputAlert: "" });
    if (!this.state.OTP) {
      this.setState({ OTPInputAlert: "Please input valid PIN" });
      return;
    }
    const url = this.props.apiprefix + 'pbcollectgetdetails?otp=' + this.state.OTP;
    uisFetch(this.props.accessToken, url, {
      method: "GET",
      headers: {  }
    })
      .then(async (response) => {
        if (response.status === 204) return null;
        if (!response.ok) return null;
        const text = await response.text();
        if (!text) return null;
        try { return JSON.parse(text); } catch { return null; }
      })
      .then((result) => {
        if (this.props.debug) console.log("[Public] pbcollectgetdetails - result = ", result);
        if (!result || Object.keys(result).length === 0) {
          this.setState({ OTPInputAlert: "No Collection Form returned. Please Try Again" });
          return;
        }
        this.setState({ detail: result });
        if (window.$) $('#btnProceed').click();
        if (window.$) $('#sig-canvas').focus();
      });
  }

  Submit = () => {
    this.setState({ SubmitAlert: "" });
    if (window.$) {
      $("#SubmitAlert").removeClass('text-success').removeClass('text-warning');
    }

    const dataUrl = this.signaturePadRef.current.getDataUrl();
    let SignatureModel = {
      CollectionID: this.state.detail.CollectionID,
      Signature: dataUrl
    };

    const url = this.props.apiprefix + 'pbcollectuploadsign?otp=' + this.state.detail.Otp;
    uisFetch(this.props.accessToken, url, {
      method: "POST",
      headers: { "Content-type": "application/json; charset=utf-8" },
      body: JSON.stringify(SignatureModel)
    })
      .then((response) => response.json())
      .then((result) => {
        if (this.props.debug) console.log("[Public] pbcollectuploadsign - result = ", result);
        if (result && result.Signature === dataUrl) {
          if (window.$) $('#btnSuccess').click();
          setTimeout(() => {
            window.location.href = process.env.PUBLIC_URL || "/";
          }, 5000);
        }
      });
  }

  CanvasClear = () => {
    this.signaturePadRef.current.clear();
    this.setState({ CanvasUpdated: false });
  }

  updateCanvas = () => {
    this.setState({ CanvasUpdated: true });
  }

  PassParmToModel(unifName, UniformId, imgIds) {
    this.setState({ modelTitle: unifName, modelUniformID: UniformId, modelImgIds: imgIds });
  }

  // Load image as Base64 with duplicate request prevention
  async loadCollectionImage(uniformId, imgId) {
    const key = `${uniformId}_${imgId}`;
    const now = Date.now();
    
    // If already have data, return directly
    if (this.state.collectionImages[key]) {
      return;
    }
    
    // If currently loading, return directly
    if (this.state.loadingImages[key]) {
      return;
    }
    
    // Check if within cooldown period
    const lastLoadTime = this.state.imageLoadTimestamps[key];
    if (lastLoadTime && (now - lastLoadTime) < this.REQUEST_COOLDOWN) {
      return;
    }
    
    // Set loading state and timestamp
    this.setState(prevState => ({
      loadingImages: {
        ...prevState.loadingImages,
        [key]: true
      },
      imageLoadTimestamps: {
        ...prevState.imageLoadTimestamps,
        [key]: now
      }
    }));
    
    try {
      const url = `${this.props.apiprefix}getimage?unm=${uniformId}&uni=${imgId}`;
      const base64Data = await fetchAndConvertToBase64(url, this.props.accessToken);
      
      if (base64Data) {
        this.setState((prevState) => ({
          collectionImages: {
            ...prevState.collectionImages,
            [key]: base64Data,
          },
          loadingImages: {
            ...prevState.loadingImages,
            [key]: false
          }
        }));
      } else {
        this.setState(prevState => ({
          loadingImages: {
            ...prevState.loadingImages,
            [key]: false
          }
        }));
      }
    } catch (error) {
      console.error(`load collection image error ${key}:`, error);
      this.setState(prevState => ({
        loadingImages: {
          ...prevState.loadingImages,
          [key]: false
        }
      }));
    }
  }

  renderItemImgModal() {
    return (
      <div className="modal fade" id='itemImgModal' role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{this.state.modelTitle}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body modal-body-autoHeight">
              {this.state.modelImgIds && this.state.modelImgIds.length > 0 ? (
                <div id="_carouselIndId" className="carousel slide" data-ride="carousel" data-interval="false">
                  <div className="carousel-inner">
                    {this.state.modelImgIds.map((m, index) => {
                      const key = `${this.state.modelUniformID}_${m.ImgId}`;
                      const blobUrl = this.state.collectionImages[key];
                      const attachmentUrl = blobUrl || ''; // fallback to empty if not loaded

                      return (
                        <div key={"modelImg" + index} className={"carousel-item " + (index === 0 ? "active" : "")}>
                          <div className="card">
                            <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                              {m.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0 ? (
                                blobUrl ? (
                                  <a target="_blank" href={blobUrl} rel="noopener noreferrer" download={m.ImgFileName}>
                                    <img className="img-thumbnail" src={blobUrl} alt="Uniform" />
                                  </a>
                                ) : <span>Loading...</span>
                              ) : (
                                <a className="card-img-top image1" href={blobUrl} target="_blank" rel="noopener noreferrer" download={m.ImgFileName}>
                                  Click to preview {m.ImgFileName}
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {this.state.modelImgIds.length > 1 && (
                    <>
                      <a className="carousel-control-prev" href="#_carouselIndId" role="button" data-slide="prev">
                        <span className="carousel-control-prev-icon carousel-control-shape" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                      </a>
                      <a className="carousel-control-next" href="#_carouselIndId" role="button" data-slide="next">
                        <span className="carousel-control-next-icon carousel-control-shape" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                      </a>
                    </>
                  )}
                </div>
              ) : (
                <img src={`${process.env.PUBLIC_URL}/Images/no-image.png`} width='100%' className="img-thumbnail w-100" />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCollectionDetail() {
    let ItemList;

    if (!this.state.IsMobileView) {
      ItemList = this.state.detail.CollectionItems?.map((m, idx) => {
        const _carouselIndId = "carouselInd" + idx;

        // preload images
        if (m.ImageList && m.ImageList.length > 0) {
          m.ImageList.forEach(m2 => {
            const key = `${m.UniformID}_${m2.ImgId}`;
            if (!this.state.collectionImages[key]) {
              this.loadCollectionImage(m.UniformID, m2.ImgId);
            }
          });
        }

        return (
          <tr key={m.UniformCode + "_" + m.SubCode}>
            <td className="font-weight-bold align-middle">
              {m.UniformDescEN} <br /> {m.UniformDescHK}
            </td>
            <td className="align-middle">
              {m.ImageList && m.ImageList.length > 0 ? (
                <div id={_carouselIndId} className="carousel slide" data-ride="carousel" data-interval="false">
                  <div
                    className="carousel-inner"
                    data-toggle="modal"
                    data-target="#itemImgModal"
                    onClick={this.PassParmToModel.bind(this, m.UniformDescEN + " " + m.UniformDescHK, m.UniformID, m.ImageList)}
                  >
                    {m.ImageList.map((m2, index) => {
                      return (
                          <div key={_carouselIndId + "carouselItem" + index} className={"carousel-item " + (index === 0 ? "active" : "")}>
                            <div className="card-header" id={m2 ? m2.imgId : 'no-id'}>
                              <div className="col-12 text-center">
                                {(() => {
                                  // 1. Safety check: prevent m2 from being undefined
                                  if (!m2 || !m2.ImgFileName) return <span>No Data</span>;

                                  const key = `${m.UniformID}_${m2.ImgId}`;
                                  const blobUrl = this.state.collectionImages[key];

                                  // 2. If no image, trigger loading and return Loading directly
                                  // Key point: return here immediately to avoid accessing m2.ImgFileName below, preventing errors
                                  if (!blobUrl) {
                                    this.loadCollectionImage(m.UniformID, m2.ImgId);
                                    return <span>Loading...</span>;
                                  }

                                  // 3. Only perform file type check when data is available
                                  if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                    return (
                                        <img
                                            src={blobUrl}
                                            className="d-block w-100 img-thumbnail"
                                            style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto" }}
                                            alt="Uniform"
                                        />
                                    );
                                  } else {
                                    return (
                                        <a className="card-img-top image1 text-center" target="_blank" rel="noopener noreferrer" download={m2.ImgFileName}>
                                          {m2.ImgFileName}
                                        </a>
                                    );
                                  }
                                })()}
                              </div>
                            </div>
                          </div>
                      );
                    })}
                  </div>
                  {m.ImageList.length > 1 && (
                    <>
                      <a className="carousel-control-prev" href={"#" + _carouselIndId} role="button" data-slide="prev">
                        <span className="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                      </a>
                      <a className="carousel-control-next" href={"#" + _carouselIndId} role="button" data-slide="next">
                        <span className="carousel-control-next-icon bg-dark" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                      </a>
                    </>
                  )}
                </div>
              ) : (
                <div className="d-flex justify-content-center">
                  <img
                    src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                    width='100%'
                    className="img-thumbnail w-100"
                    style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto" }}
                  />
                </div>
              )}
            </td>
            <td className="font-weight-bold align-middle">
              {m.SubCodeDescEN} <br /> {m.SubCodeDescHK}
            </td>
            <td className="font-weight-bold align-middle">
              {m.DistibutionLocationEN} <br /> {m.DistibutionLocationHK}
            </td>
            <td className="font-weight-bold align-middle">{m.CollectedQty}</td>
          </tr>
        );
      });
    } else {
      // Mobile view (similar logic, omitted for brevity but same pattern)
      ItemList = this.state.detail.CollectionItems?.map((m, idx) => {
        const _accordionId = "accordion" + idx;
        const _headingId = "heading" + idx;
        const _collapseId = "collapse" + idx;
        const _carouselIndId = "carouselInd" + idx;

        if (m.ImageList && m.ImageList.length > 0) {
          m.ImageList.forEach(m2 => {
            const key = `${m.UniformID}_${m2.ImgId}`;
            if (!this.state.collectionImages[key]) {
              this.loadCollectionImage(m.UniformID, m2.ImgId);
            }
          });
        }

        return (
          <div key={"mob_" + m.UniformCode + "_" + m.SubCode} className="card shadow rounded mt-2" id={_accordionId}>
            <div className="card-header cardView-header-bg-Color" id={_headingId}>
              <h5 className="mb-0 cardView-header-link" style={{ textAlign: 'left' }}>
                <a className="btn btn-link w-100" data-toggle="collapse" data-target={'#' + _collapseId} aria-expanded="true" aria-controls={_collapseId}>
                  <label className="card-text font-weight-bold h5">{m.UniformDescEN} <br /> {m.UniformDescHK}</label>
                </a>
              </h5>
            </div>
            <div id={_collapseId} className="collapse show" aria-labelledby={_headingId} data-parent={'#' + _accordionId}>
              <div className="card-body cardView-body-bg-Color text-sm-left ">
                <div className="row no-gutters">
                  <div className={"col-5 col-md-4 my-auto d-flex justify-content-center"}>
                    {m.ImageList && m.ImageList.length > 0 ? (
                      <div id={_carouselIndId} className="carousel slide" data-ride="carousel" data-interval="false">
                        <div
                          className="carousel-inner"
                          data-toggle="modal"
                          data-target="#itemImgModal"
                          onClick={this.PassParmToModel.bind(this, m.UniformDescEN + " " + m.UniformDescHK, m.UniformID, m.ImageList)}
                        >
                          {m.ImageList.map((m2, index) => {
                            return (
                                <div key={_carouselIndId + "carouselItem" + index} className={"carousel-item " + (index === 0 ? "active" : "")}>
                                  <div className="card-header" id={m2 ? m2.imgId : 'no-id'}>
                                    <div className="col-12 text-center">
                                      {(() => {
                                        if (!m2 || !m2.ImgFileName) return <span>No Data</span>;

                                        const key = `${m.UniformID}_${m2.ImgId}`;
                                        const blobUrl = this.state.collectionImages[key];

                                        if (!blobUrl) {
                                          this.loadCollectionImage(m.UniformID, m2.ImgId);
                                          return <span>Loading...</span>;
                                        }

                                        if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                          return (
                                              <img
                                                  src={blobUrl}
                                                  className="d-block w-100 img-thumbnail"
                                                  style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto" }}
                                                  alt="Uniform"
                                              />
                                          );
                                        } else {
                                          return (
                                              <a className="card-img-top image1 text-center" target="_blank" rel="noopener noreferrer" download={m2.ImgFileName}>
                                                {m2.ImgFileName}
                                              </a>
                                          );
                                        }
                                      })()}
                                    </div>
                                  </div>
                                </div>
                            );
                          })}
                        </div>
                        {m.ImageList.length > 1 && (
                          <>
                            <a className="carousel-control-prev" href={"#" + _carouselIndId} role="button" data-slide="prev">
                              <span className="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>
                              <span className="sr-only">Previous</span>
                            </a>
                            <a className="carousel-control-next" href={"#" + _carouselIndId} role="button" data-slide="next">
                              <span className="carousel-control-next-icon bg-dark" aria-hidden="true"></span>
                              <span className="sr-only">Next</span>
                            </a>
                          </>
                        )}
                      </div>
                    ) : (
                      <img
                        name={m.Seq}
                        src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                        width='100%'
                        className="img-thumbnail w-100"
                        style={{ maxHeight: "225px", maxWidth: "225px" }}
                      />
                    )}
                  </div>
                  {/* Other fields remain unchanged */}
                  <div className="col-7 col-md-8 my-auto">
                    <p className="text-center">
                      <label className="card-text">
                        <span className={"card-text font-weight-bold " + (this.state.IsTabletView == false ? (this.state.IsSmMobileView == false ? "h6" : "h6 small") : "h4")}>
                          {m.DistibutionLocationEN + " " + m.DistibutionLocationHK}
                        </span><br />
                        <span className={"text-muted " + (this.state.IsTabletView == false ? "small" : "")}>Distibution Location<br />領取地點</span>
                      </label>
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-1" />
                  <a className="btn btn-link cardView-header-link w-100 col-4 cardView-box-bg-color">
                    <label className="mt-3">
                      <span className={"font-weight-bold " + (this.state.IsTabletView == false ? "h5" : "h4")}>
                        {m.SubCodeDescEN}-{m.SubCodeDescHK}
                      </span><br />
                      <span className="text-muted">Size<br />尺碼</span>
                    </label>
                  </a>
                  <div className="col-2" />
                  <a className="btn btn-link cardView-header-link w-100 col-4 cardView-box-bg-color">
                    <label className="mt-3">
                      <span className={"font-weight-bold " + (this.state.IsTabletView == false ? "h5" : "h4")}>
                        {m.CollectedQty}
                      </span><br />
                      <span className="text-muted">Qty<br />數量</span>
                    </label>
                  </a>
                  <div className="col-1" />
                </div>
              </div>
            </div>
          </div>
        );
      });
    }

    return (
      <div className={"card-body " + (this.state.IsMobileView ? "card-body-wider" : "")}>
        {/* Staff info */}
        <div className="form-row pl-2 pr-2">
          <div className="col-sm-2"><label>Staff 姓名: </label></div>
          <div className="col-sm-10 font-weight-bold">
            {this.state.detail.StaffName} ({this.state.detail.ERN})
          </div>
        </div>
        <br />
        <div className="form-row pl-2 pr-2">
          <div className="col-sm-2"><label>Position 職位: </label></div>
          <div className="col-sm-10 font-weight-bold">{this.state.detail.Position}</div>
        </div>
        <hr />
        <div id="collectionitem" className="form-group row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
            <div className="row col-sm-12">
              <label>Collection Item(s) 可領取的制服: </label>
            </div>
            <div className="col-sm-12">
              {!this.state.IsMobileView ? (
                <div className="tableFixHead table-responsive">
                  <table className="table table-striped dt-responsive w-100">
                    <tbody>{ItemList}</tbody>
                    <thead>
                      <tr>
                        <th scope="col">Uniform<br />制服</th>
                        <th scope="col">Image<br />制服圖片</th>
                        <th scope="col">Size<br />尺碼</th>
                        <th scope="col">Distibution Location<br />領取地點</th>
                        <th scope="col">Qty<br />數量</th>
                      </tr>
                    </thead>
                  </table>
                </div>
              ) : (
                <div className="mt-2">{ItemList}</div>
              )}
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
            <div className="form-group">
              <label className="col-form-label text-info font-weight-bold mt-4 mt-lg-0">Signature 簽署確認: </label>
              <div className="col-sm-12">
                <SignaturePad
                  ref={this.signaturePadRef}
                  width={this.state.IsTabletView == false ? (this.state.IsSmMobileView == false ? 300 : 250) : 500}
                  height={this.state.IsTabletView == false ? 200 : 300}
                  onStart={() => this.setState({ CanvasUpdated: true })}
                />
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className="form-row d-flex">
          <div className="mx-auto">
            <div className={"row " + (this.state.IsMobileView ? "mb-3" : "")}>
              <a
                id="sig-submitBtn"
                hidden={!this.state.CanvasUpdated}
                className="btn btn-primary text-white"
                onClick={this.Submit.bind(this)}
              >
                Submit 提交
              </a>
              <span>&nbsp;</span>
              <button
                type="button"
                className="btn btn-secondary"
                id="sig-clearBtn"
                onClick={this.CanvasClear.bind(this)}
              >
                Clear 清除
              </button>
              <span>&nbsp;</span>
              <div id="SubmitAlert" className="font-weight-bold">{this.state.SubmitAlert}</div>
              <a id="btnSuccess" className="btn btn-info" hidden data-toggle="collapse" href="#collapseThree" role="button" aria-expanded="false" aria-controls="collapseThree">
                HIDDEN
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="container bg-secondary" style={{ minHeight: '100vh' }}>
        <div className={"col-12 " + (this.state.IsMobileView ? "card-body-wider" : "")}>
          <br style={this.state.IsMobileView ? { display: 'none' } : {}} />
          <div id="application-card" className="card border-light bg-light" style={{ minHeight: '95vh' }}>
            <div id="application-card-header" className="card-header text-white tab-fix-top">
              <div className="d-flex">
                <div className="mr-auto">
                  <h3 className={this.state.IsMobileView ? 'h5' : ''}>UIS - Collection Form 制服簽收表</h3>
                </div>
                <div>
                  <a
                    id="btnHome"
                    className="btn btn-secondary center-block"
                    href={`${process.env.PUBLIC_URL}/home`}
                    role="button"
                  >
                    <img src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-21-home.png`} width='30px' />
                  </a>
                </div>
              </div>
            </div>
            <div className={"card-body " + (this.state.IsMobileView ? "card-body-wider" : "")}>
              <form>
                <div className="form-group">
                  <div className="accordion" id="accordionExample">
                    {/* Step 1: Enter OTP */}
                    <div className="card" >
                      <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" >
                        <div className={"card-body " + (this.state.IsMobileView ? '' : 'card-body-top-space')}>
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="d-flex">
                            <div className="mx-auto">
                              <div className="form-row">
                                <h2 className="w-100 text-center">Please Type in PIN for Your Uniform Collection<br />請將認證碼輸入在以下空格</h2>
                              </div>
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="form-row">
                                <label className="col-form-label">PIN 認證碼: </label>
                                <input id="inpOTP" name="inpotp" type="number" pattern="[0-9]*" inputMode="numeric" className="form-control" value={this.state.OTP} onKeyPress={(e) => this.Go(e)} onChange={(e) => this.UpdateOTP(e)} style={{ "maxWidth": '100%', "whiteSpace": 'pre-line', "position": 'relative' }} />
                              </div>
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="gap-line col-12" />
                              <div className="form-row">
                                <a id="btnContinue" className="btn btn-info text-white" onClick={this.Proceed.bind(this)}>Continue 下一步</a>
                                <span>&nbsp;</span>
                                <div className="font-weight-bold text-danger">{this.state.OTPInputAlert}</div>
                                <a id="btnProceed" className="btn btn-info" hidden data-toggle="collapse" href="#collapseTwo" role="button" aria-expanded="false" aria-controls="collapseTwo">HIDDEN</a>
                              </div>
                            </div>
                          </div>
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                          <div className="gap-line col-12" />
                        </div>
                      </div>
                    </div>
                    {/* Step 2: Collection Details */}
                    <div className="card">
                      <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                        <div className="card-header text-secondary">
                          <label className={this.state.IsMobileView ? "h6" : "h3"}>Your Uniform Collection Details 制服簽收詳情</label>
                        </div>
                        {this.renderItemImgModal()}
                        {this.renderCollectionDetail()}
                        <a id="btnBottom" href="#sig-canvas" style={this.state.IsMobileView ? {} : { display: 'none' }}>V</a>
                      </div>
                    </div>

                    {/* Step 3: Success */}
                    <div className="card">
                      <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                        <div className="card-body">
                          <div className="d-flex">
                            <div className="mx-auto">
                              <div className="text-success"><h2>Success 完成</h2></div>
                              <div>系統將於5秒後返回首頁</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomerCollection;